import { GridFilterItem, GridSortItem } from '@mui/x-data-grid';
import { IAuthResponse, IFreeRoom, ILocation, ILocationWideResponse, IPagedLocationWideResponse } from '../Interfaces';
import { baseUrl, buildingUrl, freespaceUrl } from '../config';

export const getLocationInfo = async (guid: string | undefined, token: string):Promise<ILocation> => {

  return new Promise((resolve, reject) => {
      fetch(baseUrl + 'Buildings/' + guid, {
        method: 'GET',
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json'
        }
      }).then(response => {

        if (!response.ok) {
          // If response status is not in the success range (200-299), reject with the error text
                return response.text().then(errorText => {
                  //reject(errorText);
                  reject(new Error('An error occured. ' + errorText));
                });
              }
        resolve(response.json());
      }).catch(error => {
        reject(new Error('An error occured. ' + error));
      }
  )})
}

export const getLocationInfoWide = async (guid: string | undefined, token: string):Promise<ILocationWideResponse> => {

  return new Promise((resolve, reject) => {
      fetch(baseUrl + 'Buildings/' + guid, {
        method: 'GET',
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json'
        }
      }).then(response => {
        if (!response.ok) {
          // If response status is not in the success range (200-299), reject with the error text
                return response.text().then(errorText => {
                  reject(errorText);
                });
              }
        resolve(response.json());
      }).catch(error => {
        reject(error)
      }
  )})
}


export const  addOrUpdateBuilding = async ( data: ILocation, token: string):Promise<string> => {
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  let requestOptions:any =  {}
  let bUrl = ''
  if (data.id === '')  delete data.id;
        requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(data)
        };
          bUrl = buildingUrl
    return new Promise((resolve, reject) => {
      fetch(bUrl , requestOptions)
        .then(response => {
          if (!response.ok) {
            // If response status is not in the success range (200-299), reject with the error text
                  return response.text().then(errorText => {
                    reject(errorText);
                  });
                }
          resolve(response.text())
        }).catch((error) => {
          reject(error)
        })
    });
}


export const  addOrUpdateFreeRooms = async ( data: IFreeRoom, token: string):Promise<string> => {
  let requestOptions:any =  {}
  let bUrl = ''

    requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(data)
    };
    bUrl = freespaceUrl
  return new Promise((resolve, reject) => {
      fetch(bUrl, requestOptions)
        .then( response => {
          if (!response.ok) {
            // If response status is not in the success range (200-299), reject with the error text
                  return response.text().then(errorText => {
                    reject(errorText);
                  });
                }
          resolve(response.text())
        }).catch( () => {
          reject('Error on uploding the data')

        });
  })
}






export const deleteLocation = async ( wnummer: string, token: string):Promise<string> => {

  //if(userId === undefined) return Promise.reject('No User ID sent');

  let requestOptions:any =  {}
  let bUrl = ''

     requestOptions = {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        //body: JSON.stringify(data)
      };
      bUrl = baseUrl + 'buildings/' + wnummer
  return new Promise((resolve, reject) => {
      fetch(bUrl, requestOptions)
        .then( response => {
          if (!response.ok) {
        // If response status is not in the success range (200-299), reject with the error text
              return response.text().then(errorText => {
                reject(errorText);
              });
            }
            resolve (`The user is successfully removed`)
          }
        ).catch( (error) => {
          reject(error + 'Error on deleting the user' )
        });
  })
}


export const getRoomspace = async (wnummer: string | undefined, token: string):Promise<IFreeRoom> => {

  return new Promise((resolve, reject) => {
      if (wnummer === undefined ) reject(new Error('No parameter for query'));
      fetch(baseUrl + 'Roomspace/' + wnummer, {
        method: 'GET',
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json'
        }
      }).then(response => {
        resolve(response.json());
      }).catch(error => {
        reject(error)
      }
  )})
}


export const getHistoryLocationRoomspace = async (wnummer: string | undefined, token: string):Promise<IFreeRoom[]> => {

  return new Promise((resolve, reject) => {
      if (wnummer === undefined ) reject(new Error('No parameter for query'));
      fetch(baseUrl + 'History/' + wnummer, {
        method: 'GET',
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json'
        }
      }).then(response => {
        resolve(response.json());
      }).catch(error => {
        reject(error)
      }
  )})
}



export const GetWideLocationList = async (bearerToken: IAuthResponse):Promise<ILocationWideResponse[]> => {

  return new Promise( (resolve, reject) => {
    const url = baseUrl + 'Buildings/';
    fetch(url, {
      method: 'GET',
      headers: {
          'Authorization': 'Bearer ' + bearerToken.token,
          'Content-Type': 'application/json'
        }
    }).then( async (response) => {
        if (!response.ok) {
          return response.text().then(errorText => {
            reject(errorText);
          });
        }
        const t = await response.json()
        resolve(t);
      }).catch(error => {
        try {
          reject(error.json())
        } catch {
          console.log(error)
          reject('Unexpected error');
        }
      })
  })
}



// width per page implementation
export const GetHistoryGridData = async (bearerToken: IAuthResponse, page: number, pageSize: number,
      mySortParams: GridSortItem[],
      myFilterParams:GridFilterItem[]):Promise<IPagedLocationWideResponse> => {


  let sortString = `page=${page}&pageSize=${pageSize}`

  if (mySortParams !== undefined && mySortParams.length > 0) {
    sortString += `&sortBy=${mySortParams[0].field}&sortOrder=${mySortParams[0].sort}`
  }

  let filterString = '';
  if (myFilterParams !== undefined && myFilterParams.length > 0) {
    filterString += `&filterFld=${myFilterParams[0].field}&filterOp=${myFilterParams[0].operator}&filterVal=${myFilterParams[0].value}`
  }
  const url = baseUrl + 'History/paged?' + sortString + filterString;

  return new Promise( (resolve, reject) => {
    fetch(url, {
      method: 'GET',
      headers: {
          'Authorization': 'Bearer ' + bearerToken.token,
          'Content-Type': 'application/json'
        }
    }).then( (response) => {
        if (!response.ok) {
          return response.text().then(errorText => {
            reject(errorText);
          });
        }
        resolve(response.json());
      }).catch(error => {
        reject(error.json())
      })
  })
}